import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Vendor styles — bundled locally, no CDN.
import './assets/vendor/fontawesome/css/all.css';

// App styles.
import './styles/index.css';

// Vendor JS files (e.g. /runtime-assets/vendor/maplibre/controls/app.tms-layers.js)
// are loaded as plain <script> and cannot import ESM. Expose milsymbol on
// window so they can render SIDC-20 markers via window.tmsMilsymbol.
import ms from '@vendor-milsymbol';
window.tmsMilsymbol = ms;

import App from './App.jsx';
import { PWAProvider } from './lib/pwa.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <PWAProvider>
        <App />
      </PWAProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
